<template>
  <div id="layout">
    <el-container
      style="
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: hidden;
      "
    >
      <el-header
        class="d-flex align-items-center"
        style="background-color: #545c64"
      >
        <!-- <a class="h5 mb-0 mr-auto text-light"> {{$conf.logo}}</a> -->

        <!-- 左侧logo -->
        <div class="h5 mb-0 mr-auto text-light logoleft">
          <div class="h5navrin" style="display: none">
            <i class="el-icon-s-operation" @click="h5navrin()"></i>
          </div>
          <el-menu
            :default-active="datasource"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelecttwo"
            :menu-trigger="pcandhc"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#ffd04b"
          >
            <el-submenu :index="this.navlogoindex">
              <template slot="title">{{ this.navlogo }}</template>
              <div class="scrall" style="max-height: 80vh">
                <!-- <template > -->
                <el-menu-item
                  v-for="(item, index) in serplatarr"
                  :index="item.channel.toString()"
                  :key="index"
                  >{{ item.channel_name }}</el-menu-item
                >
                <!-- </template> -->
              </div>
            </el-submenu>
          </el-menu>
          <div class="h5las" style="display: none">
            <i class="el-icon-menu" @click="h5setup()"></i>
          </div>
        </div>

        <el-menu
          id="logoright"
          :default-active="navBar.active"
          mode="horizontal"
          @select="handleSelect"
          menu-trigger="hover"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item
            :index="index | numToString"
            v-for="(item, index) in navBar.list"
            :key="index"
          >
            {{ item.name }}
            <el-badge
              v-if="item.is_num && num_list[item.is_num] > 0"
              is-dot
              class="item"
            ></el-badge>
          </el-menu-item>

          <el-submenu index="100" @click="h5setup('1')">
            <template slot="title">
              <!-- <el-avatar size="small" :src="user.head?user.head:user_mo"></el-avatar> -->
              {{ user.name }}
            </template>
            <el-menu-item index="100-1"
              ><i class="el-icon-user"></i>修改信息</el-menu-item
            >
            <el-menu-item index="100-3"
              ><i class="el-icon-key"></i>修改密码</el-menu-item
            >
            <el-menu-item index="100-2"
              ><i class="el-icon-switch-button"></i>退出</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </el-header>
      <el-container style="height: 100%" v-if="isRouterAlive">
        <!-- 侧边布局 -->
        <el-aside
          width="200px"
          id="leftnav"
          class="bg-light"
          style="padding-bottom: 60px"
        >
          <el-menu
            :default-active="slideMenuActive"
            @select="slideSelect"
            style="height: 100%"
          >
            <el-menu-item
              :index="index | numToString"
              v-for="(item, index) in slideMenus"
              :key="index"
              v-if="item.child.length === 0"
            >
              <i :class="item.icon"></i>
              <span slot="title"
                >{{ item.name }}
                <el-badge
                  v-if="item.is_num && num_list[item.is_num] > 0"
                  :value="num_list[item.is_num]"
                  :max="99"
                  class="item ml-2"
                >
                </el-badge>
              </span>
            </el-menu-item>
            <el-submenu index="7" v-else>
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item
                :index="index + '_' + index2"
                v-for="(v, index2) in item.child"
                :key="index2"
              >
                {{ v.name }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>

        <!-- 主布局 -->
        <el-main
          class="bg-light"
          style="padding-bottom: 60px; position: relative"
          v-loading="loading"
        >
          <!-- 面包屑导航 -->
          <div
            class="border-bottom mb-3 bg-white"
            style="padding: 20px; margin: -20px"
            v-if="bran.length > 0"
          >
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item
                v-for="(item, index) in bran"
                :key="index"
                :to="{ path: item.path }"
                >{{ item.title }}</el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <!-- 主内容 -->
          <router-view @click.native="upnavall()"></router-view>

          <el-backtop target=".el-main" :bottom="100">
            <div
              style="
                 {
                  height: 100%;
                  width: 100%;
                  background-color: #f2f5f6;
                  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
                  text-align: center;
                  line-height: 40px;
                  color: #1989fa;
                }
              "
            >
              UP
            </div>
          </el-backtop>
        </el-main>
      </el-container>
    </el-container>

    <!-- 修改密码 -->
    <pass-mode :passModel="passModel" @hide="hidePassModel"></pass-mode>

    <!-- 修改个人资料 -->
    <info-edit :infoModel="infoModel" @hide="hideInfoModel"></info-edit>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
import passMode from "../components/common/pass-mode.vue";
import infoEdit from "../components/common/info-edit.vue";
import { mapState, mapMutations } from "vuex";
export default {
  mixins: [common],
  components: {
    passMode,
    infoEdit,
  },
  provide() {
    return {
      layout: this,
    };
  },
  data() {
    return {
      num_list: {},
      infoModel: false,
      user_mo:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      //navBar: [],
      bran: [],
      user: {},
      navBar: [],
      passModel: false,
      loading: false,
      webSocket: null,
      scoketUrl:
        "ws://47.242.235.44:2348?xuan_type=admin_web&token=" +
        window.sessionStorage.getItem("token"),
      datasource: "1",
      navlogo: this.$conf.logo,
      navlogoindex: "1",
      isRouterAlive: true,
      pcandhc: "hover",
      serplatarr: [],
      platformall: [], // 平台
      channelall: [], // 渠道
    };
  },
  created() {
    // 获取渠道/平台
    this.getchannel();
    //初始化菜单信息
    //this.navBar = this.$conf.navBar
    // 面包屑导航信息
    this.getRouterBran();
    // 初始化选中菜单
    this.__initNavBar();

    //this.initSocket()
    //this.getPageNum()
  },
  destroyed() {
    // 页面销毁关闭连接
    this.webSocket.close();
  },
  watch: {
    $route(to, from) {
      //console.log(to)
      // 本地存储
      localStorage.setItem(
        "navActive",
        JSON.stringify({
          top: this.navBar.active,
          left: this.slideMenuActive,
        })
      );
      //console.log(this.slideMenuActive)
      this.getRouterBran();
    },
  },
  computed: {
    slideMenuActive: {
      get() {
        let item = this.navBar.list[this.navBar.active];
        return item ? item.subActive : "0";
      },
      set(val) {
        let item = this.navBar.list[this.navBar.active];
        if (item) {
          item.subActive = val;
        }
        //console.log(this.navBar.active)
        //this.navBar.list[this.navBar.active].subActive = val
        //console.log(this.navBar.list[this.navBar.active].subActive )
      },
    },
    slideMenus() {
      let item = this.navBar.list[this.navBar.active];
      return item ? item.submenu : [];
    },
  },

  methods: {
    // 建立连接
    initSocket() {
      // 有参数的情况下：
      // 没有参数的情况:接口
      // let url1 = 'ws://localhost:9998'
      this.webSocket = new WebSocket(this.scoketUrl);
      this.webSocket.onopen = this.webSocketOnOpen;
      this.webSocket.onclose = this.webSocketOnClose;
      this.webSocket.onmessage = this.webSocketOnMessage;
      this.webSocket.onerror = this.webSocketOnError;
    },
    // 建立连接成功后的状态
    webSocketOnOpen() {
      console.log("websocket连接成功");
    },
    // 获取到后台消息的事件，操作数据的代码在onmessage中书写
    webSocketOnMessage(res) {
      // res就是后台实时传过来的数据
      if (res.data.indexOf("apiSendXuanMessage") >= 0) {
        let list = JSON.parse(res.data);
        if (list.type == "apiSendXuanMessage") {
          let data = list.data;
          if (data.type == 1) {
            this.getPageNum();
          }
        }
      }
      //给后台发送数据
      //this.webSocket.send("发送数据");
    },
    // 关闭连接
    webSocketOnClose() {
      this.webSocket.close();
      console.log("websocket连接已关闭");
    },
    //连接失败的事件
    webSocketOnError(res) {
      console.log("websocket连接失败");
      // 打印失败的数据
      console.log(res);
    },
    __initNavBar() {
      let r = localStorage.getItem("navActive");

      this.user = JSON.parse(window.sessionStorage.getItem("user"));
      this.navBar = JSON.parse(window.sessionStorage.getItem("navBar"));

      if (r) {
        r = JSON.parse(r);
        //console.log(r);
        this.navBar.active = r.top;
        this.slideMenuActive = r.left;
        //console.log(this.slideMenuActive);
        // this.toUrl()
        //console.log(this.slideMenuActive)
      }
    },
    //页面未处理数量
    getPageNum() {
      this.api
        .post("/user/adminPageNum", {})
        .then((res) => {
          let all = res.data;
          let list = all.data.list;
          this.num_list = list;
        })
        .catch((err) => {
          // 失败
        });
    },
    // 获取渠道，平台
    getchannel() {
      // 获取用户数据
      this.$store.commit(
        "login",
        JSON.parse(window.sessionStorage.getItem("user"))
      );

      // 渠道
      this.api
        .post("/data/getAllChannel", {})
        .then((res) => {
          if (res.data.code == 1) {
            this.channelall = res.data.data.list;
            if (this.channelall && this.channelall.length > 0) {
              this.$store.commit("addchannel", this.channelall);
              this.$store.commit("showchanne");
              window.sessionStorage.setItem("channelall", this.channelall);
              this.showtabtop();
            }
          }
        })
        .catch((err) => {
          // 失败
        });
      // 平台
      this.api
        .post("/data/getAllPlatform", {})
        .then((res) => {
          if (res.data.code == 1) {
            this.platformall = res.data.data.list;
            if (this.platformall && this.platformall.length > 0) {
              this.$store.commit("addplatform", this.platformall);
              window.sessionStorage.setItem("platformall", this.platformall);
            }
          }
        })
        .catch((err) => {
          // 失败
        });
    },
    // 设置渠道号切换tab
    showtabtop() {
      this.serplatarr = [...this.$store.state.user.userchannel];
      this.serplatarr.push({
        channel: 0,
        channel_name: "全部",
      });

      // 当前显示的数据源
      let DataSources = window.sessionStorage.getItem("DataSources");
      if (
        DataSources != "" &&
        DataSources != null &&
        DataSources != undefined
      ) {
        this.sernavlogo(DataSources);
        this.navlogoindex = DataSources.toString();
        this.datasource = DataSources.toString();
      } else {
        this.navlogoindex = this.serplatarr[0].channel;
        this.datasource = this.serplatarr[0].channel;
        this.navlogo = this.serplatarr[0].channel_name;
        window.sessionStorage.setItem("DataSources", this.navlogoindex);
      }
    },
    // 获取面包屑导航信息
    getRouterBran() {
      let b = this.$route.matched.filter((v) => v.name);
      let arr = [];
      b.forEach((v, k) => {
        if (v.name === "index" || v.name === "layout") return;
        arr.push({
          name: v.name,
          path: v.path,
          title: v.meta.title,
        });
      });
      if (arr.length > 0) {
        arr.unshift({
          name: "index",
          path: "/index",
          title: "后台首页",
        });
      }
      this.bran = arr;

      var h5width = document.body.clientWidth;
      if (h5width <= 750) {
        this.pcandhc = "click";
      } else {
        this.pcandhc = "hover";
      }
    },
    hideInfoModel() {
      let user = JSON.parse(window.sessionStorage.getItem("user"));
      this.user.name = user.name;
      this.user.head = user.head;
      this.infoModel = false;
    },
    hidePassModel() {
      this.passModel = false;
    },
    handleSelect(key, keyPath) {
      if (key === "100-1") {
        return (this.infoModel = true);
        //console.log('修改个人信息');
      }
      if (key === "100-3") {
        return (this.passModel = true);
      }
      if (key === "100-2") {
        //退出
        return this.logout();
      }
      // console.log(key, keyPath);
      this.navBar.active = key;
      // 跳转到当前激活
      this.slideMenuActive = "0";
      //console.log(this.slideMenuActive);
      if (this.slideMenus.length > 0) {
        this.$router.push({
          name: this.slideMenus[this.slideMenuActive].pathname,
        });
      }
      this.upnavall();
    },
    // 刷新组件
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    sernavlogo(key) {
      for (let i in this.serplatarr) {
        if (this.serplatarr[i].channel == key) {
          this.navlogo = this.serplatarr[i].channel_name;
          break;
        }
      }
    },
    // logo切换数据源
    handleSelecttwo(key, keyPath) {
      this.sernavlogo(key);
      window.sessionStorage.setItem("DataSources", key);
      this.navlogoindex = key;
      this.reload();
      this.upnavall();
    },
    // serinluo(item){
    // 	// 落地页渠道只在打点页面显示
    // 	if(item.name.indexOf('落地页') != -1){
    // 		if(this.$route.path == '/data/dadian'){
    // 			return true;
    // 		}else{
    // 			return false;
    // 		}
    // 	}else{
    // 		return true;
    // 	}
    // },
    logout() {
      //请求接口
      this.api
        .post("/user/logout", {})
        .then((res) => {
          //成功后
          this.$message("退出成功");
          this.$store.commit("logout");
          //返回到登录页
          this.$router.push({
            name: "login",
          });
        })
        .catch((err) => {
          //失败
          this.$message("退出成功");
          this.$store.commit("logout");
          this.$router.push({
            name: "login",
          });
        });
    },
    slideSelect(key, keyPath) {
      //console.log(key, keyPath);
      //this.navBar.list[this.navBar.active].subActive = key
      this.slideMenuActive = key;

      //console.log(this.slideMenuActive);
      this.toUrl();
      this.h5navrin();
      this.h5setup("1");
    },
    upnavall() {
      this.h5setup("1");
      this.h5navrin("1");
    },
    h5navrin(val) {
      // H5隐藏侧边导航栏
      var h5width = document.body.clientWidth;
      if (h5width <= 750) {
        // this.h5setup('1')
        var leftnav = document.getElementById("leftnav");
        var rightstyle = window.getComputedStyle(leftnav).left;
        if (val != "" && val != null && val != undefined) {
          // 主页面点击关闭侧导航栏
          leftnav.style.left = "-160px";
        } else {
          if (rightstyle == "0px") {
            leftnav.style.left = "-160px";
          } else if (rightstyle == "-160px") {
            leftnav.style.left = "0px";
          }
        }
      }
    },
    h5setup(val) {
      // H5隐藏侧边导航栏
      var h5width = document.body.clientWidth;
      if (h5width <= 750) {
        var leftsetup = document.getElementById("logoright");
        var leftstyle = window.getComputedStyle(leftsetup).right;
        if (val != "" && val != null && val != undefined) {
          // 主页面点击关闭侧导航栏
          leftsetup.style.right = "-120px";
        } else {
          if (leftstyle == "5px") {
            leftsetup.style.right = "-120px";
          } else if (leftstyle == "-120px") {
            leftsetup.style.right = "5px";
          }
        }
      }
    },
    toUrl(val = 0, query = {}) {
      let keys = new Array(); //定义一数组
      if (val == 0) {
        keys = this.slideMenuActive.split("_");
      } else {
        this.slideMenuActive = val;
        keys = val.split("_");
      }
      if (keys.length === 2) {
        this.$router.push({
          name: this.slideMenus[keys[0]].child[keys[1]].pathname,
          query: query,
        });
      } else {
        //跳转到指定页面
        this.$router.push({
          name: this.slideMenus[this.slideMenuActive].pathname,
          query: query,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#leftnav {
  ul {
    height: auto !important;
    min-height: 100% !important;
  }
}
.scrall {
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
